import {filter, find, get, includes, map} from "lodash";
import {EntityTypes} from "../../Notifications/NotificationsLib";
import {getSignDocPrefix} from "../../SignDoc/SignDocLib";
import {getSignDocsInOrganizationLearningPathsAPI} from "../../../Services/api";

export const getTaskOptionsForNotificationsInOrganization = async ({
                                                                 selectedOrgOption,
                                                                 adminOrganizations,
                                                                 showPastSignDocs,
                                                                 i18n,
                                                                 addAllOption = false,
                                                                 doNotforceCompletion = false
                                                             }) => {
    let signDocOptionsTmp = []
    let yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    if (selectedOrgOption === 'all') {
        //get all courses from all organizations
        let orgSignDocs = []
        map(adminOrganizations, (org) => {
            let tmpOrgSignDocs = get(org, 'organization.signDocs')
            tmpOrgSignDocs = tmpOrgSignDocs.filter((signDoc) => {
                const orgSignDoc = find(signDoc.organizationSignDoc, {OrganizationId: get(org, 'organization.id')})
                if (doNotforceCompletion) {
                    return orgSignDoc.isValid && signDoc.doNotForceCompletion === true
                } else {
                    if (!showPastSignDocs) {
                        return orgSignDoc.isValid && new Date(orgSignDoc.finishByDate) >= yesterday && !signDoc.doNotForceCompletion
                    } else {
                        return orgSignDoc.isValid && signDoc.doNotForceCompletion === false
                    }
                }
            })
            orgSignDocs = orgSignDocs.concat(tmpOrgSignDocs)
        })

        signDocOptionsTmp = map(orgSignDocs, (signDoc) => {
            let prefix = getSignDocPrefix({signDoc, i18n});
            return {
                value: signDoc.id,
                text: `${prefix} - ${signDoc.docName}`,
                type: EntityTypes.SIGN_DOC
            }
        })


    } else {
        const selectedOrganizationData = find(adminOrganizations, {organization: {id: selectedOrgOption}})
        let orgSignDocs = get(selectedOrganizationData, 'organization.signDocs')
        // Get list of SignDocs that are part of learning paths for the selected organization
        const learningPathSignDocIds = await getSignDocsInOrganizationLearningPathsAPI({
            organizationId: selectedOrgOption
        });

        orgSignDocs = filter(orgSignDocs, (signDoc) => {
            const orgSignDoc = find(signDoc.organizationSignDoc, {OrganizationId: get(selectedOrganizationData, 'organization.id')})
            if (doNotforceCompletion) {
                return orgSignDoc.isValid && signDoc.doNotForceCompletion === true
            }
            if (!showPastSignDocs) {
                return orgSignDoc.isValid && new Date(orgSignDoc.finishByDate) >= yesterday && !signDoc.doNotForceCompletion
            } else {
                return orgSignDoc.isValid && signDoc.doNotForceCompletion === false
            }

        })

        // Filter to only include SignDocs that are part of learning paths
        orgSignDocs = filter(orgSignDocs, (signDoc) =>
            !includes(learningPathSignDocIds, signDoc.id))

        signDocOptionsTmp = map(orgSignDocs, (signDoc) => {
            let prefix = getSignDocPrefix({signDoc, i18n});
            return {
                value: signDoc.id,
                text: `${prefix} - ${signDoc.docName}`,
                type: EntityTypes.SIGN_DOC
            }
        })


    }
    //unique signDocs options
    signDocOptionsTmp = filter(signDocOptionsTmp, (signDoc, index, self) => index === self.findIndex((t) => (t.value === signDoc.value)))
    if(addAllOption){
        signDocOptionsTmp.unshift({
            value: 'all',
            text: i18n.translate('automations.createAutomationModal.allCourses'),
            type: null
        })
    }
    signDocOptionsTmp.unshift({
        value: '', text: '', type: null
    })
    //add empty option to signDocs
    return {signDocOptionsTmp};
}

export const AutomationStatus = {
    SCHEDULED: 'SCHEDULED',
    COMPLETED: 'COMPLETED',
    PAUSED: 'PAUSED'
}